import React from 'react';

export default function GridPattern({ className = '', style = {} }) {
  const baseStyle = {
    pointerEvents: 'none',
    position: 'absolute',
    display: 'inline-flex',
    width: '384px',
    flexWrap: 'wrap',
    alignContent: 'center',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '20px',
    opacity: '0.1',
    ...style, // Merge custom styles
  };

  const dotStyle = {
    height: '4px',
    width: '4px',
    transform: 'rotate(45deg)',
    backgroundColor: '#d4d4d8',
  };

  return (
    <div className={className} style={baseStyle}>
      {Array.from({ length: 192 }).map((_, i) => (
        <div key={i} style={dotStyle} />
      ))}
    </div>
  );
}
